import { LoggingStrategy } from '@/logger/strategies';
import {LogContext, LogLevel} from '@/logger';

export class NoOpLoggingStrategy implements LoggingStrategy {
  log(_level: LogLevel, _message: string, _context?: LogContext, _error?: Error | unknown): void {
    // Intentionally do nothing - useful for tests or disabled logging
  }

  isEnabled(_level: LogLevel): boolean {
    return false;
  }
}
